module.exports = __webpack_public_path__ + "static/media/tringale.f915c986.png";